import { defineNuxtPlugin } from '#app/nuxt'
import { LazyABTest, LazyAccordion, LazyAccordionItem, LazyActiveEvents, LazyBlok, LazyCard, LazyCategoryEventsOverview, LazyCategoryList, LazyClubSso, LazyContentSection, LazyFabricksAuthentication, LazyFullWidthContent, LazyGiveaway, LazyHeroCallToAction, LazyHeroSlider, LazyLocalisationContainer, LazyNewsArticles, LazyNewsletter, LazyPage, LazyProductSlider, LazyProductsOverview, LazyRichText, LazySlider, LazyTable, LazyTrustPilot, LazyVideo, LazyYoutubeVideo, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["ABTest", LazyABTest],
["Accordion", LazyAccordion],
["AccordionItem", LazyAccordionItem],
["ActiveEvents", LazyActiveEvents],
["Blok", LazyBlok],
["Card", LazyCard],
["CategoryEventsOverview", LazyCategoryEventsOverview],
["CategoryList", LazyCategoryList],
["ClubSso", LazyClubSso],
["ContentSection", LazyContentSection],
["FabricksAuthentication", LazyFabricksAuthentication],
["FullWidthContent", LazyFullWidthContent],
["Giveaway", LazyGiveaway],
["HeroCallToAction", LazyHeroCallToAction],
["HeroSlider", LazyHeroSlider],
["LocalisationContainer", LazyLocalisationContainer],
["NewsArticles", LazyNewsArticles],
["Newsletter", LazyNewsletter],
["Page", LazyPage],
["ProductSlider", LazyProductSlider],
["ProductsOverview", LazyProductsOverview],
["RichText", LazyRichText],
["Slider", LazySlider],
["Table", LazyTable],
["TrustPilot", LazyTrustPilot],
["Video", LazyVideo],
["YoutubeVideo", LazyYoutubeVideo],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
